import { memo } from "react";

import DeleteButton from "./delete-button";
import ReminderButton from "./remider-button";
import DeactivateButton from "./deactivate-button";

function ActionButtons({ editModalHandler, showReminder, rowData }) {
  return (
    <div>
      <button
        className="btn btn-warning btn-sm mr-1"
        onClick={editModalHandler}
        style={{ color: "black", fontWeight: "bold" }}
      >
        Edit
      </button>
      <DeleteButton id={rowData?._id} />
      <button
        className="btn btn-success btn-sm mr-1"
        disabled
        style={{ cursor: "not-allowed" }}
      >
        Open Tasks
      </button>
      <DeactivateButton rowData={rowData} />
      {showReminder && rowData?.active && (
        <ReminderButton emailId={rowData?.email} />
      )}
    </div>
  );
}

export default memo(ActionButtons);
